import { createContext, useContext } from 'react';

import { INITIAL_PERMISSION, IPermissionContext } from './permission.context.model';

export const PermissionContext = createContext<IPermissionContext>(INITIAL_PERMISSION);

export const usePermissionContext = () => useContext(PermissionContext);
